import {ethers} from "ethers";
import { ChainProvider, ContractFacade } from "./abstact/ContractFacade";
import { ERC20HelperABI } from "./abi/ERC20HelperABI";

export class ERC20Helper extends ContractFacade
{
    constructor(address:string, provider:ChainProvider)
    {
        super(address, ERC20HelperABI.GetABI(), provider);
    }

    async getNames(erc20Adrs:string[]): Promise<string[]>
    {
        const result = await this._call("getNames",erc20Adrs);
        return result;
    }

    async getSymbols(erc20Adrs:string[]): Promise<string[]>
    {
        const result = await this._call("getSymbols",erc20Adrs);
        return result;
    }   
}